<ng-progress></ng-progress>
<div style="display: flex;" *ngIf="authentication && !isEmailAssessment" >
  <div *ngIf="menuPermissions.sideBarMenu" class="widthSidebar">
    <app-sidebar [confirmCastValue]="confirmCastValue"></app-sidebar>
  </div>
  <div *ngIf="isBrandingCompleted" [ngClass]="menuPermissions.sideBarMenu ? 'widthHeader' : 'widthHeader-noSideBar'">
    <app-header [confirmCastValue]="confirmCastValue"></app-header>
    <router-outlet *ngIf="authentication"></router-outlet>
  </div>
  <app-session-popup (resetTimer)="reset()"></app-session-popup>
</div>

<div *ngIf="isEmailAssessment" >
  <router-outlet></router-outlet>
</div>
<div   *ngIf="!isEmailAssessment && !authentication" >
  <router-outlet></router-outlet>
</div>


<app-confimation-popup [Header]="'Confirm'" [ConfirmButton]="'OK'" [DisCardButton]="'Cancel'" [Message]="message" (modalEvent)="getModalEvent($event)"></app-confimation-popup>
<app-alert (popupHideCallback)="popupHideCallback($event)" *ngIf="error" [Message]="errorMessage"></app-alert>
